import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { auth } from '../../firebase/firebase-config';
import { sendChatMessage } from '../../services/chatService';
import { useUser } from '../../context/UserContext';
import { resolveProfileDisplayName } from '../../platform/displayName';
import './MessageCompose.css';

function ChatMessageForm({ tenantId, unit }) {
  const [newMessage, setNewMessage] = useState('');
  const { user } = useUser();

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !tenantId) return;

    const firebaseUser = auth.currentUser;
    if (!firebaseUser) return;

    const displayName = resolveProfileDisplayName(user) || 'Uporabnik';

    await sendChatMessage({
      tenantId,
      unitId: unit,
      text: newMessage,
      user: {
        uid: firebaseUser.uid,
        displayName,
        email: user?.email || firebaseUser.email || '',
      },
    });
    setNewMessage('');
  };

  return (
    <Form onSubmit={handleSendMessage} className="message-compose">
      <Form.Control
        type="text"
        placeholder="Napišite sporočilo…"
        value={newMessage}
        onChange={(e) => setNewMessage(e.target.value)}
        className="message-compose__input"
        aria-label="Napišite sporočilo"
        required
      />
      <Button variant="primary" type="submit" className="message-compose__submit">
        Pošlji
      </Button>
    </Form>
  );
}

export default ChatMessageForm;
